<template lang="pug">
  .uploaded-file
    .file-icon
      inline-svg(:src="require('./document-file.svg')" width="40" height="40")
    .fileinfo
      //.id {{file.id}}
      .filename {{file.filename}}
      .filesize {{prettyBytes(Number(file.size), {locale: 'ru'})}}
      // .mimetype {{file.mimetype}}
</template>

<script lang="ts" setup>
import prettyBytes from "pretty-bytes";
import {computed} from "vue";
import InlineSvg from "vue-inline-svg";

const props = defineProps({
  file: {
    type: Object,
  }
})

const file = computed(() => props.file)
</script>

<style scoped lang="less">
.uploaded-file {
  display: flex;

  align-items: flex-start;
  flex-direction: column;
  max-width: 20rem;

  .fileicon {

  }

  .fileinfo {
    font-size: 1.2rem;
    .filename {
      font-weight: bolder;
      font-size: 1.4rem;
      word-wrap: anywhere;
      user-select: none;
    }
    .filesize {
      padding-top: 0.3rem;
      font-size: 0.8rem;
      user-select: none;
    }
  }
}
</style>
